export default "__VITE_ASSET__2ol5DiOW__"